import $ from "jquery";
import AutoPlayer, { throttleActivity } from "../../classes/AutoPlayer";

window.featuredAutoPlayState = null;
window.modalAutoPlayState = null;

export function stopFeaturedAutoPlay() {
    if (window.featuredAutoPlayState) {
        window.featuredAutoPlayState.stopAndHide();
        window.featuredAutoPlayState = null;
    }
}

export function cleanupModalAutoPlay() {
    if (window.modalAutoPlayState) {
        window.modalAutoPlayState.destroy();
        window.modalAutoPlayState = null;
    }
}

export function stopAllAutoPlay() {
    stopFeaturedAutoPlay();
    cleanupModalAutoPlay()
}

export function startModalAutoPlay(streamUrl) {
    if (!streamUrl) return;

    const $modal = $('#movieDetailModal');
    const $screenshot = $modal.find('.featured-screenshot');

    const $muteBtn = $('<button>', { id: 'modal-mute-toggle', class: 'autoplay-player-button autoplay-player-mute-button-details' })
        .html('<ion-icon name="volume-mute"></ion-icon>');

    window.modalAutoPlayState = new AutoPlayer({
        streamUrl: streamUrl,
        playerId: 'modal-inline-player',
        wrapperId: 'modal-inline-player-wrapper',
        $screenshot: $screenshot,
        $muteBtn: $muteBtn,
        injectDOM: ($wrapper) => {
            $wrapper.addClass('autoplay-player-wrapper-details');
            $screenshot.after($wrapper);
            $screenshot.closest('.gradient-bg').append($muteBtn);
        }
    });

    window.modalAutoPlayState.init();

    $modal.one('hidden.bs.modal', stopAllAutoPlay);
}

// +++++++++++++++++++++++++++++++++++++++++++++++

export function startInactivityAutoPlay(streamUrl) {
    stopAllAutoPlay();
    if (!streamUrl) return;

    const $screenshot = $('.featured-screenshot');
    const $muteBtn = $('<button>', { id: 'featured-mute-toggle', class: 'autoplay-player-button autoplay-player-mute-button-featured' })
        .html('<ion-icon name="volume-mute"></ion-icon>');

    // Calculate height
    let height = $screenshot.outerHeight();
    const $firstRowInner = $('#content .row__inner').first();

    if ($firstRowInner.length) {
        const gradientRect = $screenshot.closest('.gradient-bg')[0].getBoundingClientRect();
        const rowInnerRect = $firstRowInner[0].getBoundingClientRect();
        const availableHeight = rowInnerRect.top - gradientRect.top;
        if (availableHeight > 0) height = availableHeight;
    }

    // Dynamic mute button positioning for featured player using imported throttle
    const positionMuteBtn = throttleActivity(() => {
        const $gradientBg = $('.gradient-bg');
        if ($gradientBg.length) {
            const rect = $gradientBg[0].getBoundingClientRect();
            const navbarHeight = $('nav').first().outerHeight() || 0;
            const visibleTop = Math.max(rect.top, navbarHeight);
            $muteBtn.css({ top: `${visibleTop + 12}px`, left: `${rect.right - 60}px` });
        }
    });

    $(window).on('resize scroll', positionMuteBtn);

    window.featuredAutoPlayState = new AutoPlayer({
        streamUrl: streamUrl,
        playerId: 'featured-inline-player',
        wrapperId: 'featured-inline-player-wrapper',
        $screenshot: $screenshot,
        $muteBtn: $muteBtn,
        height: height,
        injectDOM: ($wrapper) => {
            $wrapper.addClass('autoplay-player-wrapper-featured');
            $screenshot.closest('.gradient-bg').prepend($wrapper);
            $('body').append($muteBtn);
        },
        onShow: () => positionMuteBtn(),
        onCleanup: () => $(window).off('resize scroll', positionMuteBtn)
    });

    window.featuredAutoPlayState.init();
}